import React, { useState, useEffect } from 'react';
import { protectedAPI } from '../services/api';
import { AuthProvider, useAuth } from '../context/AuthContext';
import JournalTable from './JournalTable';
import {usePagination} from './PaginationHook.js';
import './Pagination.css'
import './Plates.css'
import PaginationControls from './PaginationControls'
import {TableSearch, JournalTableRow} from './SearchFilter'
import SwapVertIcon from '@mui/icons-material/SwapVert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ru';
import dayjs, { Dayjs } from 'dayjs';

export const SortingTableHeader = ({ onClick, column, columnName = ''  }) => {
  const [sortDir, setSortDir] = useState('asc');

  const handleSortClick = () => {
    if (sortDir == 'asc')
      setSortDir('desc');
    else if (sortDir == 'desc')
      setSortDir('asc')

    onClick({sortBy: column, sortDir: sortDir});
  };

  return (
    <th className='sortable' onClick={handleSortClick}>
      {columnName} <SwapVertIcon className='modern-icon'></SwapVertIcon>
    </th>
  );
};

const Journal = () => {
  const [addresses, setAddresses] = useState([]);
  const [journalByAddress, setJournalByAddress] = useState([]);
  const [filters, setFilters] = useState({});
  const [sortings, setSortings] = useState({});
  const { user, logout } = useAuth();
  const [openCreateReport, setOpenCreateReport] = useState(false);
  const [reportDateFrom, setReportDateFrom] = useState(dayjs());
  const [reportDateTo, setReportDateTo] = useState(dayjs());

  const {
    data,
    pagination,
    loading,
    error,
    fetchData
  } = usePagination(protectedAPI.getJournalByAddress, 1, 20, 39);

  const handlePageChange = (newPage) => {
    fetchData(newPage, pagination.pageSize, filters);
  };

  const handlePageSizeChange = (newPageSize) => {
    fetchData(1, newPageSize, filters);
  };

  const handleSearch = (searchFilters) => {
    setFilters(searchFilters);
    fetchData(1, pagination.pageSize, searchFilters);
  };

  const handleSortClick = (sortings) => {
    setSortings(sortings);
    fetchData(1, pagination.pageSize, filters, sortings);
  };

  const handleCreateReport = () => {
    setOpenCreateReport(true);
  };

  const handleCloseCreateReport = () => {
    setOpenCreateReport(false);
  }

  if (error) {
    return (
      <div className="error-message">
        Ошибка загрузки данных: {error}
        <button onClick={() => fetchData(1, pagination.pageSize, filters)}>
          Повторить
        </button>
      </div>
    );
  }

  return (
    <div>
      <header>
        <h1>Журнал событий</h1>
      </header>
      <div className="table-container">
        <div className='search-line'>
          <TableSearch onSearch={handleSearch} />
          {/*}
          <Button variant="outlined" onClick={handleCreateReport}>
            Отчет
          </Button>
          {*/}
        </div>

        <Dialog
          open={openCreateReport}
          onClose={handleCloseCreateReport}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Создать отчет
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box
                component="form"
                sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                noValidate
                autoComplete="off"
              >
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ru'>
                  <DatePicker
                    label="Начало"
                    value={reportDateFrom}
                    onChange={(newValue) => setReportDateFrom(newValue)}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ru'>
                  <DatePicker
                    label="Конец"
                    value={reportDateTo}
                    onChange={(newValue) => setReportDateTo(newValue)}
                  />
                </LocalizationProvider>
                  
                <TextField
                  required
                  id="new-number"
                  label="Номер"
                  
                />
                <TextField
                  id="new-rule-controlled"
                  label="Права доступа"
                >
                </TextField>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseCreateReport}>Отменить</Button>
            <Button autoFocus>
              Добавить
            </Button>
          </DialogActions>
        </Dialog>

        <div className="table-wrapper">
          <table className="modern-table">
            <thead>
              <tr>
                <SortingTableHeader
                  onClick={handleSortClick}
                  column='license_plate_number_ru'
                  columnName='Номер'
                />
                <SortingTableHeader
                  onClick={handleSortClick}
                  column='address'
                  columnName='Адрес'
                />
                <SortingTableHeader
                  onClick={handleSortClick}
                  column='camera'
                  columnName='Камера'
                />
                <SortingTableHeader
                  onClick={handleSortClick}
                  column='recognized_at'
                  columnName='Дата'
                />
                <SortingTableHeader
                  onClick={handleSortClick}
                  column='access_granted'
                  columnName='Проезд'
                />
                <th>
                  Действия
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="loading-cell">
                    Загрузка...
                  </td>
                </tr>
              ) : (
                data.map((item) => (
                  <JournalTableRow key={item.id} data={item} />
                ))
              )}
            </tbody>
          </table>
        </div>

        <PaginationControls
          pagination={pagination}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Journal;